// src/lib/appsScript.js

export const APPS_SCRIPT_URL =
    process.env.REACT_APP_APPS_SCRIPT_URL ||
    "https://script.google.com/macros/s/AKfycbwX9qPvYtWE68MZOTUAlJdRRYOLcncAN530lazdue6NKJl8nJS_HCUH_LWEsj_236TQTQ/exec";